module.exports = __webpack_public_path__ + "fonts/0136bea0e65115e7090887b1bbe50fb2.txt";